import { FACEBOOK_INTEGRATIONS_URL } from 'api/FacebookIntegrationsAPI';
import { useRestQuery } from 'utils/hooks/api/useRestQuery';
import { FacebookIntegration } from '../domain/facebook';

type FacebookIntegrationRequest = {
  adAccountIds?: string[];
};

type FacebookIntegrationResponse = FacebookIntegration[];

export const useGetFacebookIntegration = () => {
  const {
    data = [],
    isLoading,
    isError,
    isSuccess,
    refetch,
  } = useRestQuery<FacebookIntegrationResponse, FacebookIntegrationRequest>(
    FACEBOOK_INTEGRATIONS_URL,
    {},
    { refetchOnMount: false, staleTime: Infinity },
  );

  return {
    data,
    isLoading,
    isError,
    isSuccess,
    refetch,
  };
};
